import React from 'react';
type WordmarkProps = {
  inverted?: boolean;
};
export function Wordmark({
  inverted = false
}: WordmarkProps) {
  return <span className="inline-flex items-baseline gap-1.5" aria-label="NEXT OS" data-id="element-77" data-mp="3twd44f2lp3fr">
      <span className={`font-display text-2xl font-extrabold italic tracking-tight ${inverted ? 'text-white' : 'text-brand'}`} data-id="element-78" data-mp="2iqlh05gzm2d">
        NEXT
      </span>
      <span className={`rounded border px-1.5 py-0.5 text-[11px] font-bold tracking-wider ${inverted ? 'border-white/30 text-white' : 'border-ink/20 text-ink'}`} data-id="element-79" data-mp="35zp9flc17um4">
        OS
      </span>
    </span>;
}